import { lazy } from 'react';

export const LazyIdentVerificationPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--ident-verification-page" */ './ident-verification-page'
    ),
);
